import React from 'react';
import HighlightBanner from '@hpstellar/core/HighlightBanner';

import withPageComponents from '../../page/components/with-page-components';

import './results-footer-banner.less';

const ResultsFooterBanner = ({ vwaResultsFooterBanner }) => {
    if (!vwaResultsFooterBanner || !vwaResultsFooterBanner[0]) return null;
    return <HighlightBanner {...vwaResultsFooterBanner[0]} slim />;
};

export default withPageComponents(ResultsFooterBanner, { components: ['vwaResultsFooterBanner'] });
